module.exports = __webpack_public_path__ + "static/a-new-earth-671690ba2877f5829d0f8c443cab6a7d.jpg";